import authRoutes from './auth'
import authGuard from '@/auth/AuthGuard'
import { RouteRecordRaw } from 'vue-router'
import subscriptionGuard from './subscriptionGuard'
import accountDisabledGuard from './accountDisabledGuard'
import v1SubscriptionGuard from './v1SubscriptionGuard'
import { isEBEnv } from '@/helpers/env'

const sandboxGuard = () => {
  if (!isEBEnv('local')) {
    return { name: 'app' }
  }
  return true
}

export const desktopRoutes: Array<RouteRecordRaw> = [
  ...authRoutes,
  {
    path: '/health',
    name: 'health',
    component: () => import('../views/_Health.vue'),
  },
  {
    path: '/sandbox',
    name: 'sandbox',
    beforeEnter: sandboxGuard,
    component: () => import('../views/sandbox/ColorSandbox.vue'),
  },
  {
    path: '/',
    name: 'app',
    beforeEnter: [authGuard, accountDisabledGuard],
    component: () => import('../views/MainView.vue'),
    children: [
      {
        path: 'bank-callback',
        name: 'bankCallback',
        component: () => import('../views/BankCallbackView.vue'),
      },
      {
        path: 'subscription-expired',
        name: 'subscriptionExpired',
        component: () => import('../views/SubscriptionExpired.vue'),
      },
      {
        path: 'subscription-extended',
        name: 'subscriptionExtended',
        component: () => import('../views/SubscriptionExtended.vue'),
      },
      {
        path: 'test-data/:secret/:transactionsPerMonth',
        name: 'testData',
        component: () => import('../views/test-data/TestDataGenerate.vue'),
      },
      {
        path: 'demo-data/:secret',
        name: 'demoData',
        component: () => import('../views/test-data/DemoDataGenerate.vue'),
      },
      {
        path: 'marketing-data/:secret',
        name: 'marketingData',
        component: () => import('../views/test-data/MarketingDataGenerate.vue'),
      },
      {
        path: 'budget',
        beforeEnter: subscriptionGuard,
        component: () => import('../layouts/LayoutDefault.vue'),
        children: [
          {
            path: ':budgetId/import-budget',
            name: 'budgetImport',
            meta: { showSidePanel: false },
            components: {
              main: () => import('../views/ImportBudgetView.vue'),
            },
          },
          {
            path: ':budgetId/statistics',
            name: 'statistics',
            meta: { showSidePanel: false },
            components: {
              main: () => import('../views/StatisticsViewDesktop.vue'),
            },
          },
          {
            path: ':budgetId/import',
            name: 'importTransactions',
            meta: { showSidePanel: false },
            components: {
              main: () =>
                import(
                  '../features/transaction-import/views/ImportTransactionsView.vue'
                ),
            },
          },
          {
            path: ':budgetId/settings',
            name: 'budgetSettings',
            meta: { showSidePanel: false },
            components: {
              main: () => import('../views/BudgetSettingsViewDesktop.vue'),
            },
          },
          {
            path: ':budgetId/period/:periodKey',
            alias: [':budgetId'],
            name: 'budget',
            components: {
              main: () => import('../views/BudgetViewContainerDesktop.vue'),
            },
          },
          {
            path: ':budgetId/loans/:loanId?',
            name: 'loans',
            components: {
              main: () =>
                import('../features/loans/views/desktop/LoanView/LoanView.vue'),
            },
          },
          {
            path: ':budgetId/bank-connection/:bankConnectionId',
            name: 'bankConnectionOnboardingStatus',
            components: {
              main: () =>
                import('../views/BankConnectionOnboardingStatusView.vue'),
            },
          },

          {
            path: ':budgetId/bank-connections',
            name: 'bankConnections',
            meta: { showSidePanel: false },
            components: {
              main: () =>
                import(
                  '../features/bank-connections/views/BankConnectionsView.vue'
                ),
            },
          },
          {
            path: ':budgetId/transactions',
            name: 'transactions',
            meta: { showSidePanel: false },
            components: {
              main: () =>
                import(
                  '../features/transactions/views/desktop/TransactionsView/TransactionsView.vue'
                ),
            },
          },
          {
            path: ':budgetId/transaction-sides',
            name: 'transactionSides',
            meta: { showSidePanel: false },
            components: {
              main: () =>
                import(
                  '../features/transaction-sides/views/desktop/TransactionSidesView/TransactionSidesView.vue'
                ),
            },
          },
        ],
      },
      {
        path: 'budgets',
        component: () => import('../layouts/LayoutEmpty.vue'),
        children: [
          {
            path: '',
            name: 'budgetsList',
            component: () =>
              import('../views/SettingsBudgetListViewDesktop.vue'),
          },
        ],
      },
      {
        path: 'settings',
        component: () => import('../layouts/LayoutEmpty.vue'),
        children: [
          {
            path: 'subscription',
            name: 'settingsSubscription',
            beforeEnter: v1SubscriptionGuard,
            meta: { header: 'Subskrypcja', showSidePanel: false },
            component: () =>
              import('../views/SettingsSubscriptionViewDesktop.vue'),
          },
          {
            path: 'reminders',
            name: 'settingsReminder',
            meta: { header: 'Przypomnienia', showSidePanel: false },
            component: () => import('../views/SettingsReminderViewDesktop.vue'),
          },
          {
            path: 'subscription-new',
            name: 'subscriptionNew',
            component: () =>
              import('../features/subscription/views/SubscriptionNewView.vue'),
          },
        ],
      },
    ],
  },
]
